import { bloomProperty } from "./bloom-property";
import { PropertyGroup } from "../../property-group";

export const miscGroup = new PropertyGroup("Miscellaneous", [bloomProperty])
